// RequestPasswordReset.js
import React, {useEffect} from "react";
import Navbar from "../../components/NavBar";
import {useTranslation} from "react-i18next";
import privacyPolicyText from "./privacyPolicyText"; // Import privacy policy content from a separate file
import "./PrivacyPage.css";

const PrivacyPage = () => {
    const {t, i18n} = useTranslation();

    useEffect(() => {
        // Set the default language to Italian when the page loads
        i18n.changeLanguage("it");
    }, [i18n]);


    return (
        <div className="d-flex">
            <div
                style={{
                    flex: "1 1 auto",
                    display: "flex",
                    flexFlow: "column",
                    height: "100vh",
                    overflowY: "hidden",
                }}
            >
                <Navbar/>
                <div className="privacy-page">
                    <div className="privacy-container">
                        <h2>{t("privacy_policy")}</h2>
                        <div className="privacy-content">
                            {privacyPolicyText.map((section, index) => (
                                <div key={index}>
                                    <h3>{t(section.title)}</h3>
                                    <p>{t(section.content)}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="privacy-actions">
                        <button className="accept-button" onClick={() => window.close()}>
                            {t("accept")}
                        </button>
                        <button className="refuse-button" onClick={() => window.close()}>
                            {t("refuse")}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPage;
